const POSITIVE_INTEGER = /^[1-9]\d*$/

export const isValidClassId = (classId: string | number | undefined) =>
  POSITIVE_INTEGER.test(String(classId))
